import { jsxs, jsx } from 'react/jsx-runtime';
import { space } from '../../constants.js';
import { ErrorIcon } from '../../icons/ErrorIcon.js';
import { Flex } from '../Flex/Flex.js';

const ErrorMessage = ({ children, iconSize = 14, removeBottomMargin, ...restProps })=>jsxs(Flex, {
        color: "red",
        display: "inline-flex",
        mb: removeBottomMargin ? "s0" : "s4",
        ...restProps,
        children: [
            jsx(ErrorIcon, {
                fixedSize: iconSize,
                style: {
                    marginRight: space.s2
                }
            }),
            jsx("span", {
                children: children
            })
        ]
    });

export { ErrorMessage };
